export default __webpack_public_path__ + "static/media/hostfullyLogo.a3716eac.svg";